import axios from "axios"
import { endPoints } from "@fixed/endPoints"
import { getUserData } from "../../Utils"

export const fetch = async (endPoint, id = null, params = null, method = 'GET') => {
    // const { accessToken: token } = getUserData()
    let url = `${process.env.REACT_APP_HOST_URI}${endPoints[endPoint]}`

    if (params?.extraUrl) {
        url += `/${params.extraUrl}`
        delete params.extraUrl
    }


    const requestConfig = {
        method,
        headers: {
            'Content-type': 'application/json'
            // 'x-token': token
        }
    }

    try {
        switch (method) {
            case 'GET':
                requestConfig['params'] = params
                break
            case 'POST':
            case 'PUT':
                requestConfig['method'] = (method === 'POST' && id) ? 'PUT' : method
                requestConfig['data'] = params
                break
            case 'DELETE':
                requestConfig['params'] = params

                break
            default:
                break
        }

        url += id ? `/${id}` : ''
        console.log(url, requestConfig)
        const { data } = await axios(url, requestConfig)
        console.log(data, 'data')

        return data
    } catch (error) {
        console.error(error)
        return false
    }
}
